import * as React from 'react'
import { FormGroup, Button, HTMLSelect } from '@blueprintjs/core'
import { useDispatch, useSelector } from 'react-redux'
import qz from '../qz'
import { QZHIDDevice } from '../types'
import { AppState } from '../../store'
import { setCurrentHIDDevice } from '../../current/actions'
import { isNotableHIDDevice } from '../utils'

const ScalePicker: React.FC<{}> = () => {
  const dispatch = useDispatch()
  const { currentHIDDevice } = useSelector((s: AppState) => ({
    currentHIDDevice: s.current.currentHIDDevice,
    connected: s.current.qzConnection.connected
  }))

  const [list, setList] = React.useState<QZHIDDevice[]>([])
  const [loading, setLoading] = React.useState(false)

  const retrieveList = async () => {
    setLoading(true)
    try {
      let devices = await qz.hid.listDevices()
      devices = devices.filter(isNotableHIDDevice).sort((a, b) => (a.manufacturer > b.manufacturer ? 1 : -1))
      setList(devices)
      if (currentHIDDevice && currentHIDDevice.vendorId && currentHIDDevice.productId) {
        const currentDeviceInList = devices.find(
          (d: QZHIDDevice) =>
            d && d.vendorId === currentHIDDevice.vendorId && d.productId === currentHIDDevice.productId
        )
        if (!currentDeviceInList) {
          dispatch(setCurrentHIDDevice(null))
        }
      }
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    retrieveList()
  }, [])

  return (
    <div>
      <FormGroup disabled={loading} label="Scale" helperText="Make sure scales are powered on">
        <HTMLSelect
          value={currentHIDDevice ? currentHIDDevice.productId : ''}
          disabled={loading}
          onChange={e => {
            const device = list.find((d: QZHIDDevice) => d && d.productId === e.target.value) || null
            dispatch(setCurrentHIDDevice(device))
          }}
        >
          <option value="">No scale selected</option>
          {list.map((p: QZHIDDevice) => (
            <option key={p.productId} value={p.productId}>
              {[p.manufacturer, p.product].filter(i => i).join(' ')}
            </option>
          ))}
        </HTMLSelect>
        {!loading && <Button onClick={retrieveList} minimal icon="refresh" />}
      </FormGroup>
    </div>
  )
}

export default ScalePicker
